export {default} from '../../core/components/Header';